import { render, staticRenderFns } from "./RealTIme.vue?vue&type=template&id=524c822b&scoped=true&"
import script from "./RealTIme.vue?vue&type=script&lang=js&"
export * from "./RealTIme.vue?vue&type=script&lang=js&"
import style0 from "./RealTIme.vue?vue&type=style&index=0&id=524c822b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c822b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VDataTable,VPagination,VTextField})
